import React, { Component } from 'react';
import { EmployerService } from '../Services';
import { AutoComplete } from '.';
import { IEmployerFilterParams } from '../Models';

interface IEmployersFilterState {
    employersNameList: string[];
    nameFilter: string;
}

interface IEmployersFilterProps {
    filterEmployersList: (employersFilterParams: IEmployerFilterParams) => void;
    labeledYears?: string[];
    employersTitle: string;
    search: string;
    searchEmployer: string;
}

export class EmployersFilter extends Component<
    IEmployersFilterProps,
    IEmployersFilterState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            employersNameList: [],
            nameFilter: '',
        };
    }
    componentDidMount() {
        void this.getEmployersNameList();
    }

    async getEmployersNameList() {
        const employersNameList = await EmployerService.getAllEmployersName();
        this.setState({ employersNameList });
    }

    handleOnSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        this.props.filterEmployersList({
            name: this.state.nameFilter,
            page: 0,
            labeledYears: this.props.labeledYears,
        });
    };

    handleNameModification = (userInput: string) => {
        this.setState({ nameFilter: userInput });
    };

    handleClickOnCompletion = (userInput: string) => {
        this.setState({ nameFilter: userInput });

        this.props.filterEmployersList({
            name: userInput,
            page: 0,
            labeledYears: this.props.labeledYears,
        });
    };

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-2">
                        <h1>{this.props.employersTitle}</h1>

                        <form
                            className="form-search"
                            onSubmit={this.handleOnSubmit}
                            data-skip-captcha="true"
                        >
                            <div className="form-group">
                                <AutoComplete
                                    suggestions={this.state.employersNameList}
                                    filterName={this.handleNameModification}
                                    search={this.props.searchEmployer}
                                    clickOnCompletion={
                                        this.handleClickOnCompletion
                                    }
                                    userInput={this.state.nameFilter}
                                />
                            </div>

                            <div className="form-group submit">
                                <button type="submit">
                                    <i className="icon-search"></i>
                                    {this.props.search}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
